import React, { useState } from 'react';
import moment from 'moment/moment';
import {
  FDDateInput, FDIcon,
  FDList,
  FDListItem,
  FDListItemText,
  FDListItemTextRightAligned,
  FDStack,
} from '@facet-wealth/design';
import { FilterControl } from './filterControl';

export function GuidedHouseholdReviewGoalListFilterControls({
  resource, startDate, setStartDate, endDate, setEndDate, typesToShow, setTypesToShow,
}) {
  const [controlToShow, setControlToShow] = useState();
  const typeOptionIDs = new Set(resource.attr('goalList')?.resources()?.list()?.map(goal => goal.attr('type')) ?? []);
  const typeOptions = (resource.attr('goalList')?.resources()?.head()?.metaField('type')
    ?.options()
    ?.list() || []).filter(option => typeOptionIDs.has(option.id()));

  const toggleType = (id) => setTypesToShow(shown => {
    // Copy the set of shown types and either remove or add this type to toggle it
    const newSet = new Set(shown);
    if (newSet.has(id)) {
      newSet.delete(id);
    } else {
      newSet.add(id);
    }
    return newSet;
  });

  return (
    <FDStack direction="row" spacing={2} justifyContent="flex-end">
      {typeOptions.length > 0 && (
        <FilterControl
          label="Filter by type"
          open={controlToShow === 'type'}
          setOpen={(val) => setControlToShow(val ? 'type' : undefined)}
        >
          <FDStack padding={2}>
            <FDList disablePadding>
              {Array.from(typeOptions).map(type => (
                <FDListItem key={type.id()} onClick={() => toggleType(type.id())}>
                  <FDListItemText primaryText={type.attr('prompt')} />
                  {typesToShow.has(type.id()) ? (
                    <FDListItemTextRightAligned
                      primaryText={(
                        <FDStack direction="row" justifyContent="flex-end" alignSelf={'center'}>
                          <FDIcon icon="check" color="textPrimary" />
                        </FDStack>
                    )}
                    />
                  ) : null}
                </FDListItem>
              ))}
            </FDList>
          </FDStack>
        </FilterControl>
      )}

      <FilterControl
        label="Filter by year"
        open={controlToShow === 'year'}
        setOpen={(val) => setControlToShow(val ? 'year' : undefined)}
      >
        <FDStack padding={3} direction="column" spacing={2}>
          <FDDateInput
            value={startDate?.toISOString()}
            onChange={(val) => setStartDate(val ? moment(val).startOf('year') : undefined)}
            label="Start year"
            inputFormat="YYYY"
          />
          <FDDateInput
            value={endDate?.toISOString()}
            onChange={(val) => setEndDate(val ? moment(val).endOf('year') : undefined)}
            label="End year"
            inputFormat="YYYY"
          />
        </FDStack>
      </FilterControl>
    </FDStack>
  );
}
